import React from "react";
import "./Badge.css";

export type BadgeProps = {
  variant?: "default" | "secondary" | "destructive" | "outline" | "success" | "warning";
  size?: "sm" | "md";
  className?: string;
  children?: React.ReactNode;
};

export const Badge = ({
  variant = "default",
  size = "md",
  className = "",
  children,
  ...props
}: BadgeProps & React.ComponentPropsWithoutRef<"span">) => {
  
  const getVariantClass = () => {
    switch (variant) {
      case "default":
        return "ds2-badge-default";
      case "secondary":
        return "ds2-badge-secondary";
      case "destructive":
        return "ds2-badge-destructive";
      case "outline":
        return "ds2-badge-outline";
      case "success":
        return "ds2-badge-success";
      case "warning":
        return "ds2-badge-warning";
      default:
        return "ds2-badge-default";
    }
  };

  const getSizeClass = () => {
    switch (size) {
      case "sm":
        return "ds2-badge-sm";
      case "md":
      default:
        return "ds2-badge-md";
    }
  };

  return (
    <span 
      className={`ds2-badge ${getVariantClass()} ${getSizeClass()} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
};